module.exports = __webpack_public_path__ + "img/nacho.aa9d371e.png";